module.exports = __webpack_public_path__ + "static/IMG_3034-34b524ae3b7b02de6c5645882c5178ca.jpg";